import React from 'react';
import { motion } from 'framer-motion';
import { User, Sparkles, Bot } from 'lucide-react';
import { cn } from '../../utils/cn';
export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  isStreaming?: boolean;
}
interface ChatMessageProps {
  message: Message;
}
export function ChatMessage({
  message
}: ChatMessageProps) {
  const isAI = message.role === 'assistant';
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    ease: 'easeOut'
  }} className={cn('flex w-full gap-3 mb-4', isAI ? 'justify-start' : 'justify-end')} data-id="element-349">
      {isAI && <div className="flex-shrink-0 mt-1" data-id="element-350">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-500" data-id="element-351">
            <Sparkles className="h-4 w-4" data-id="element-352" />
          </div>
        </div>}

      <div className={cn('relative max-w-[85%] rounded-lg px-4 py-3 text-sm shadow-sm', isAI ? 'bg-[#1a1d23] border border-gray-800 text-gray-200' : 'bg-gray-800 text-white')} data-id="element-353">
        <div className="whitespace-pre-wrap leading-relaxed" data-id="element-354">
          {message.content}
          {message.isStreaming && <span className="inline-block w-1.5 h-4 ml-1 align-middle bg-amber-500 animate-pulse" data-id="element-355" />}
        </div>
        <div className="mt-1 text-[10px] text-gray-500 text-right opacity-70" data-id="element-356">
          {message.timestamp.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </div>
      </div>

      {!isAI && <div className="flex-shrink-0 mt-1" data-id="element-357">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-700 text-gray-300" data-id="element-358">
            <User className="h-4 w-4" data-id="element-359" />
          </div>
        </div>}
    </motion.div>;
}